import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./popupsidebar.css";
import home from "../../assets/images/menu/home.svg";
import markets from "../../assets/images/menu/markets.svg";
import holdings from "../../assets/images/menu/holdings.svg";
import wallet from "../../assets/images/menu/wallet.svg";
import alert from "../../assets/images/menu/alert.svg";
// import apps from "../../assets/images/menu/apps.svg";
import homeActive from "../../assets/images/menu/home-active.svg";
import marketsActive from "../../assets/images/menu/markets-active.svg";
import holdingsActive from "../../assets/images/menu/holdings-active.svg";
import walletActive from "../../assets/images/menu/wallet-active.svg";
import alertActive from "../../assets/images/menu/alert-active.svg";
import account from "../../assets/images/account.svg";
import accountActive from "../../assets/images/accountActive.svg";
// import appsActive from "../../assets/images/menu/apps-active.svg";
// import logo from "../../assets/images/logo.svg";
// import refer from "../../assets/images/menu/refer-inactive.svg";
// import { useDispatch, useSelector } from "react-redux";

const PopupSidebar = ({ handleOpenMenu }) => {
  const { pathname } = useLocation();
  // const liveDemo = useSelector((state) => state.page.liveDemo);
  // const dispatch = useDispatch();
  const sidebarItems = [
    {
      name: "Markets",
      img: markets,
      activeImage: marketsActive,
      active: pathname === "/",
      path: "/?technicals",
    },
    {
      name: "Home",
      img: home,
      activeImage: homeActive,
      active: pathname.startsWith("/home"),
      path: "/home",
    },

    {
      name: "Positions",
      img: holdings,
      activeImage: holdingsActive,
      active: pathname.startsWith("/positions"),
      path: "/positions",
    },
    {
      name: "Wallet",
      img: wallet,
      activeImage: walletActive,
      active: pathname.startsWith("/wallet"),
      path: "/wallet",
    },
    {
      name: "Alert",
      img: alert,
      activeImage: alertActive,
      active: pathname.startsWith("/alert"),
      path: "/alert",
    },
    {
      name: "Account",
      img: account,
      activeImage: accountActive,
      active: pathname.startsWith("/accounts"),
      path: "/accounts",
    },
    // {
    //   name: "Apps",
    //   img: apps,
    //   activeImage: appsActive,
    //   active: pathname.startsWith("/apps"),
    //   path: "/apps",
    // },
  ];
  // const handleLiveDemo = (status) => {
  //   dispatch({ type: "setLiveDemo", payload: status });
  // };

  return (
    <>
      <div className="h-[100vh] !sticky !z-[100] pt-20">
        <div className="user-profile-container">
          <Link to="/?technicals">
            <svg
              // className="ml-[1.37rem]"
              width="100%"
              height="100%"
              viewBox="0 0 940 206"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M865.04 63.1738H877.533V206H865.04V63.1738Z"
                fill="#161616"
              />
              <path
                d="M802.573 6.86662C802.573 3.07429 805.649 0 809.444 0H933.129C936.924 0 940 3.0743 940 6.86663V71.4131C940 75.2054 936.924 78.2797 933.129 78.2797H809.444C805.649 78.2797 802.573 75.2054 802.573 71.4131V6.86662Z"
                fill="#19F256"
              />
              <path
                d="M207.232 167.966H210.403V205.997H207.232V167.966Z"
                fill="#161616"
              />
              <path
                d="M197.707 164.799H220.964V179.251H197.707V164.799Z"
                fill="#19F256"
              />
              <path
                d="M75.0351 8.23995H119.149V205.999H75.0351V128.955H44.114V205.999H0V8.23995H44.114V85.2836H75.0351V8.23995Z"
                fill="#161616"
              />
              <path
                d="M228.858 8.23995L285.752 205.999H239.989L206.594 90.6396L173.2 205.999H127.437L184.744 8.23995H228.858Z"
                fill="#161616"
              />
              <path
                d="M403.99 8.23995H447.692V205.999H403.578V107.119L380.49 159.443H361.113L338.025 107.119V205.999H293.911V8.23995H338.025L371.008 82.3996L403.99 8.23995Z"
                fill="#161616"
              />
              <path
                d="M574.297 8.23995H617.999V205.999H573.885V107.119L550.797 159.443H531.42L508.332 107.119V205.999H464.218V8.23995H508.332L541.315 82.3996L574.297 8.23995Z"
                fill="#161616"
              />
              <path
                d="M727.701 8.23995L784.596 205.999H738.833L705.438 90.6396L672.043 205.999H626.28L683.587 8.23995H727.701Z"
                fill="#161616"
              />
            </svg>

            {/* <img src="https://res.cloudinary.com/ddlupbcws/image/upload/v1680791936/logo_2_ft9ja_1_fsh9iz.png" alt="" className='w-[5.75rem] ml-[1.37rem] mb-[4.06rem]' /> */}
          </Link>
        </div>
        <div className="item-list">
          {sidebarItems.map((item, index) => (
            <div key={index}>
              <Link
                to={item.path}
                onClick={handleOpenMenu}
                className="menu-item"
              >
                <img
                  src={item.active ? item.activeImage : item.img}
                  alt={`${item.name} Logo`}
                />
                <span className={`item-name ${item.active ? "white" : "grey"}`}>
                  {item.name}
                </span>
              </Link>
            </div>
          ))}
          {/* <div>
            <Link
              target="_blank"
              to={`https://refer.gohamma.com/?token=${localStorage.getItem(
                "access_token"
              )}&refresh_token=${localStorage.getItem("refresh_token")}`}
              className="sidebar-menu-item"
            >
              <img src={refer} alt="Refer Icon" />
              <span className="item-name grey">Refer</span>
            </Link>
          </div> */}
          {/* <div>
            <Link
              target="_blank"
              to="https://swipe.gohamma.com/"
              className="sidebar-menu-item"
            >
              <svg
                width="24"
                height="26"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="7"
                  y="5"
                  width="12"
                  height="14"
                  rx="2"
                  fill="white"
                  fillOpacity="0.25"
                />
                <rect
                  x="5"
                  y="7"
                  width="12"
                  height="14"
                  rx="2"
                  fill="white"
                  fillOpacity="0.4"
                />
                <path
                  d="M2 12H5M1 10L3 12L1 14"
                  stroke="white"
                  strokeOpacity="0.4"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22 12H19M23 10L21 12L23 14"
                  stroke="white"
                  strokeOpacity="0.4"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="item-name grey">Swipe</span>
            </Link>
          </div> */}
          <div>
            {/* The AI tab. Guests opening it are sent on to the /ai landing page. */}
            <Link
              to="/?ai"
              onClick={handleOpenMenu}
              className="sidebar-menu-item"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="26"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#FFFFFFCC"
                  d="M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z"
                />
              </svg>

              <span className="item-name grey">AI</span>
            </Link>
          </div>
        </div>
      </div>
      {/* <div className="mobileLiveDemoContainer">
        <div
          onClick={() => handleLiveDemo(false)}
          className={`mobileDemoDiv ${!liveDemo && "activeMobileLiveDemo"}`}
        >
          <p>Demo</p>
        </div>
        <div
          onClick={() => handleLiveDemo(true)}
          className={`mobileLiveDiv ${liveDemo && "activeMobileLiveDemo"}`}
        >
          <p>Live</p>
        </div>
      </div> */}
    </>
  );
};

export default PopupSidebar;
